export enum CallDirection {
	Inbound = 'Inbound',
	Outbound = 'Outbound',
	Internal = 'Internal',
	Unknown = 'Unknown'
}